import { render, staticRenderFns } from "./indexDialog.vue?vue&type=template&id=7977934e&scoped=true"
import script from "./indexDialog.vue?vue&type=script&lang=js"
export * from "./indexDialog.vue?vue&type=script&lang=js"
import style0 from "./indexDialog.vue?vue&type=style&index=0&id=7977934e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7977934e",
  null
  
)

export default component.exports